import { ReactNode } from 'react';
import clsx from 'clsx';

interface Props {
  variant?: 'accent' | 'success' | 'danger' | 'info' | 'neutral';
  children: ReactNode;
}

export function Badge({ variant = 'accent', children }: Props) {
  return (
    <span className={clsx(
      'inline-flex items-center px-2 py-0.5 rounded-md text-xs font-medium',
      variant === 'accent'  && 'bg-accent-muted text-accent-text',
      variant === 'success' && 'bg-green-50 text-success',
      variant === 'danger'  && 'bg-red-50 text-danger',
      variant === 'info'    && 'bg-blue-50 text-info',
      variant === 'neutral' && 'bg-page text-text-muted border border-border',
    )}>
      {children}
    </span>
  );
}
